import { getFromStorage } from 'Shared/utils/storage';

export function getStationType() {
  return getFromStorage('stationType') || 'DC';
}

export const isAdmin = () => {
  return getStationType() === 'ADMIN';
};

export function getCurrentStationId() {
  return +getFromStorage('stationId');
}

export function getStationName() {
  return getFromStorage('stationName');
}
